module.exports = {
    siteTitle: 'Uusi asiakas',
    siteTitleAlt: 'Uusi asiakas',
    siteDescription:
      'Uusi asiakkuus Wihurin eMetro-palvelussa.',
    language: 'fi',
    locale: 'fi-FI'
}
